export default "__VITE_ASSET__Cy0dFkAB__"